import { Helmet } from 'react-helmet-async';
import { useEffect } from 'react';

const UsePostDetailHelmet = ({ slug, post, breadcrumb }) => {
  useEffect(() => {
    console.log('[SEO]', {
      title: post?.title,
      desc: post?.meta_description,
      slug,
    });
  }, [slug, post]);

  return (
    post && (
      <Helmet key={slug || post?.id || 'default'}>
        <title>
          {slug && post?.title
            ? `${post.title} | Thành Đồng Group`
            : `${breadcrumb.title || 'Bài viết'} | Thành Đồng Group`}
        </title>
        <meta
          name="description"
          content={
            slug && post?.meta_description
              ? post.meta_description
              : 'Chống thấm cần thơ, Vệ sinh công nghiệp, Giúp việc nhà cần thơ , Vệ sinh Cần thơ, Di dời cần thơ, thành đồng cần thơ, giúp việc nhà theo giờ.'
          }
        />
        <meta
          name="keywords"
          content={
            slug && post?.meta_keywords
              ? post.meta_keywords
              : 'thành đồng, tin tức, bài viết, chống thấm, vệ sinh cần thơ'
          }
        />
        <meta name="author" content="Thành Đồng Group" />
        <meta name="robots" content="index, follow" />

        <meta property="og:type" content="article" />
        <meta
          property="og:title"
          content={
            slug && post?.meta_title
              ? post.meta_title
              : `Bài viết | Thành Đồng Group`
          }
        />
        <meta
          property="og:description"
          content={
            slug && post?.meta_description
              ? post.meta_description
              : `Khám phá các bài viết chuyên môn và hoạt động của Thành Đồng Group.`
          }
        />
        <meta
          property="og:image"
          content={
            slug && post?.thumbnail
              ? post.thumbnail
              : 'https://thanhdongct.com/favicon.ico' // hoặc URL ảnh mặc định đẹp hơn
          }
        />
        <meta property="og:url" content={window.location.href} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>
    )
  );
};

export default UsePostDetailHelmet;
